import React from "react";
import { 
    Button
} from './styles'

const SmallButton = ({...props}) => {
    return(
        <Button onClick={props.function} disabled={props.isDisabled}>{props.name}</Button>
    )
}
export default SmallButton;
